import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'lib-chevron-down-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      fill="none"
      [style.color]="color()"
      [class]="iconClass()">
      <path
        d="M11.9465 5.45325H7.79316H4.05317C3.41317 5.45325 3.09317 6.22658 3.5465 6.67991L6.99983 10.1332C7.55317 10.6866 8.45317 10.6866 9.0065 10.1332L10.3198 8.81991L12.4598 6.67991C12.9065 6.22658 12.5865 5.45325 11.9465 5.45325Z"
        fill="currentColor" />
    </svg>
  `,
})
export class ChevronDownIconComponent extends BaseIconComponent {
  override viewBox = input<string>('0 0 16 16');
}
